module.exports = __webpack_public_path__ + "img/3diamond-07.251a809e.svg";